
export enum AzureResourceType {
    Queue,
    Topic,
    ServiceBus
}
